import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { datadogRum } from "@datadog/browser-rum";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { ADONIS_DYNAMIC_CTA_BANNER_PERSISTENCE_KEY } from "@/modules/adonis/useAdonis/useAdonisDynamicCTABanner";
import { LocalStorageService } from "@/modules/storage";
import { useAppState } from "contexts/AppContext";
import { Analytics } from "modules/analytics";
import {
  type LauncherKey,
  resetAppIcon,
} from "modules/appIcon/helpers/appIcon.helpers";
import { ThemeContext } from "pages/Root";
import Services from "services/Services";
import { setPromotionModalSeen } from "utils/functions";

interface UseLogoutProps {
  subdomain?: string | null;
}

export const useLogout = ({ subdomain }: UseLogoutProps = {}) => {
  const navigate = useNavigate();
  const appState = useAppState();
  const { resetTheme } = useContext(ThemeContext);

  return async () => {
    // Clear analytics identity to disassociate device from user session
    Analytics.reset();

    appState.clear();

    setPromotionModalSeen(false);
    await Services.auth.clearAll();
    LocalStorageService.removeItem("locationConfirmed");
    LocalStorageService.removeItem(ADONIS_DYNAMIC_CTA_BANNER_PERSISTENCE_KEY);
    datadogRum.clearUser();

    if (Capacitor.isNativePlatform()) {
      console.info("[APPS-2365] Clearing preferences for native platform.");
      Preferences.clear();

      const disable = subdomain ? [`launcher_${subdomain}`] : [];

      await resetAppIcon(disable as LauncherKey[]);

      resetTheme();
    }

    navigate("/signin");
  };
};
